import React, { useState, useEffect, useRef } from 'react'
import useAxios from '../../hooks/useAxios'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { useAuth } from '../../contexts/AuthContext'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Dialog } from 'primereact/dialog'
import { Toast } from 'primereact/toast';
import { ProgressBar } from 'primereact/progressbar'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import MsisdnSearch from '../../components/MsisdnSearch';

const APIURL = '/api/summa-cfs'

const SummaCfs = () => {
  const { user } = useAuth()
  const { response, error, setError, loading, fetchData } = useAxios()

  const [msisdn, setMsisdn] = useState(992)
  const [data, setData] = useState(null)
  const [selectedRow, setSelectedRow] = useState({ cftype: '', activationState: '', ftn: '' })
  const [editDialog, setEditDialog] = useState(false)


  const toast = useRef(null);
  const dt = useRef(null);

  const handleSearch = (msisdnValue) => {
    setMsisdn(msisdnValue)
    fetchData({ method: 'get', url: APIURL, params: { msisdn: msisdnValue } })
  }

  useEffect(() => {
    if (!response) return;

    // Show toast for messages
    if (response.message) {
      const severity = response.status === "error" ? "error" : response.status;
      toast.current.show({ severity, detail: response.message, life: 3000 });
    }

    // Update data on success (response has cfs array directly)
    if (response.status === "success" && response.cfs) {
      setData(response);
    } else if (response.status === "error") {
      setData(null);
    }
  }, [response]);


  const handleEditRow = (row) => {
    setSelectedRow(row)
    setEditDialog(true)
  }

  const handleDeleteAccept = () => {
    const dataUpdated = { ...selectedRow, msisdn: msisdn, action: 'delete' }
    fetchData({ method: 'post', url: APIURL, 'data': dataUpdated })
  }

  const reject = () => {
    console.log("rejected");

  }

  const handleDeleteRow = (row) => {
    setSelectedRow(row)
    confirmDialog({
      message: `Вы уверены, что хотите снять переадресацию ${row.cftype}?`,
      header: 'Внимание!',
      icon: 'pi pi-info-circle',
      defaultFocus: 'reject',
      acceptClassName: 'p-button-danger',
      acceptLabel: 'Да',
      rejectLabel: 'Нет',
      accept: handleDeleteAccept,
      reject: () => console.log("rejected")
    });

  }

  const handleEditDialogSave = () => {
    const dataUpdated = { ...selectedRow, msisdn: msisdn, action: 'edit' }
    fetchData({ method: 'post', url: APIURL, 'data': dataUpdated })
    //data.status === 'success' && setData(prevState => (prevState.data.cfs.map(obj => obj.cftype === selectedRow.cftype ? { ...obj, ftn: selectedRow.ftn } : obj)))
    setEditDialog(false)
  }

  const handleEditDialogCancel = () => {
    setEditDialog(false)
  }

  const handleEditDialogChange = (e) => {
    setSelectedRow({ ...selectedRow, ftn: e.target.value })
  }


  const editDialogFooter = (
    <React.Fragment>
      <div className='flex'>
        <Button label="Отмена" icon="pi pi-times" outlined onClick={handleEditDialogCancel} className='p-button-warning w-full' />
        <Button label="Сохранить" icon="pi pi-check" onClick={handleEditDialogSave} className='p-button-warning w-full mr-0' disabled={selectedRow.ftn === ""} />
      </div>
    </React.Fragment>
  )

  const actionTemplate = (rowData) => {
    return (
      <div className="flex">
        <Button icon="pi pi-pencil" rounded text raised className="mr-2" severity="warning" onClick={() => handleEditRow(rowData)} />
        <Button icon="pi pi-trash" rounded text raised className="mr-2" severity="warning" disabled={rowData.activationState === 'NOT_ACTIVE'} onClick={() => handleDeleteRow(rowData)} />
      </div>
    )
  }



  if (!user) return null

  return (
    <>
      <Toast ref={toast} position="top-right" />
      <ConfirmDialog />
      <MsisdnSearch onSubmit={handleSearch} loading={loading} title="Переадресации" description="Настройка и просмотр переадресаций вызовов по номеру MSISDN" />

      {
        loading ? (
          <div className="mt-6">
            <ProgressBar mode="indeterminate" style={{ height: '7px' }} ></ProgressBar>
          </div>
        ) : (
          <>
            {data?.cfs?.length > 0 && (
              <div className='px-3 mt-6' >
                <DataTable header={`Переадресации, установленные на номер ${msisdn}`} ref={dt} value={data.cfs} size='small' showGridlines style={{ fontSize: '0.85rem'}} >
                  <Column field="cftype" header="Тип переадресации"></Column>
                  <Column field="ftn" header="FTN-номер"></Column>
                  <Column field="activationState" header="Статус"></Column>
                  <Column body={actionTemplate} exportable={false} header="Редактирование"></Column>
                </DataTable>
              </div>
            )}
          </>
        )
      }

      <Dialog header="Редактирование" visible={editDialog} modal className="p-fluid" onHide={() => { if (!editDialog) return setEditDialog(false) }} footer={editDialogFooter}>
        <div className="field">
          <label htmlFor="ftn" className="font-bold">FTN-номер</label>
          <InputText id="ftn" name="ftn" value={selectedRow.ftn} onChange={handleEditDialogChange} />
        </div>
      </Dialog >
    </>
  )
}

export default SummaCfs